<ng-container>
  <div class="tabs is-fullwidth is-toggle">
    <ul>
      <li [class.is-active]="active === 0">
        <a routerLink="rules">
          <span>Regler</span>
        </a>
      </li>
      <li [class.is-active]="active === 1">
        <a routerLink="wsclients">
          <span>Integrerande System</span>
        </a>
      </li>
    </ul>
  </div>

  <router-outlet></router-outlet>
</ng-container>
